import Engagement from "../../redux/models/engagement";
import K from "../../utilities/constants";
import Export from "../../redux/models/export";
import { ServerSideDataGrid } from "../../common/components/serverSideDataGrid/serverSideDataGrid";

export const TabsConfig = {
  thisWeek: {
    key: "thisWeek",
    label: "Due This Week",
    tableConfigKey: K.AgGridTable.Keys.ThisWeekEngagementsVisibleColumn,

    getData: (params) =>
      Engagement.get({
        ...params,
        timeFrame: "thisWeek",
        state: "pending",
        candidateJobStatusId: 9,
      }),

    onExport: (params) =>
      Export.getReportEngagements({
        ...params,
        timeFrame: "thisWeek",
        state: "pending",
        candidateJobStatusId: 9,
      }),

    renderComponent: (props) => (
      <ServerSideDataGrid key="thisWeek" {...props} />
    ),
  },
  pastDue: {
    key: "pastDue",
    label: "Past Due",
    tableConfigKey: K.AgGridTable.Keys.PastDueEngagementsVisibleColumn,

    getData: (params) =>
      Engagement.get({
        ...params,
        timeFrame: "pastDue",
        state: "pending",
        candidateJobStatusId: 9,
      }),

    onExport: (params) =>
      Export.getReportEngagements({
        ...params,
        timeFrame: "pastDue",
        state: "pending",
        candidateJobStatusId: 9,
      }),

    renderComponent: (props) => <ServerSideDataGrid key="pastDue" {...props} />,
  },
  future: {
    key: "future",
    label: "Future",
    tableConfigKey: K.AgGridTable.Keys.FutureEngagementsVisibleColumn,

    getData: (params) =>
      Engagement.get({
        ...params,
        timeFrame: "future",
        state: "pending",
        candidateJobStatusId: 9,
      }),

    onExport: (params) =>
      Export.getReportEngagements({
        ...params,
        timeFrame: "future",
        state: "pending",
        candidateJobStatusId: 9,
      }),

    renderComponent: (props) => <ServerSideDataGrid key="future" {...props} />,
  },
};
